import { z } from 'zod';

// Base allergen schema (response from API)
export const allergenSchema = z.object({
  _id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  icon: z.string().optional(),
  image: z.string().optional(),
  _idRestaurant: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

// Schema for creating allergen
export const createAllergenSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  description: z.string().optional(),
  icon: z.string().min(1, 'Icon is required'),
  image: z.string().optional(),
});

// Schema for updating allergen (all fields optional)
export const updateAllergenSchema = z.object({
  name: z.string().min(1, 'Name is required').optional(),
  description: z.string().optional(),
  icon: z.string().optional(),
  image: z.string().optional(),
});

// Inferred types
export type TAllergen = z.infer<typeof allergenSchema>;
export type TCreateAllergenRequest = z.infer<typeof createAllergenSchema>;
export type TUpdateAllergenRequest = z.infer<typeof updateAllergenSchema>;

// Generic API response wrapper (reusable for all APIs)
export type TApiResponse<T> = {
  success: boolean;
  code: number;
  msg: string;
  serverTime: string;
  data: {
    rows: T[];
    count: number;
  };
};

// Single item API response wrapper
export type TApiSingleResponse<T> = {
  success: boolean;
  code: number;
  msg: string;
  serverTime: string;
  data: T;
};

// API Response types
export type TAllergensResponse = TApiResponse<TAllergen>;
export type TAllergenResponse = TApiSingleResponse<TAllergen>;
